<template>
    <div class="c-checkbox" @click.prevent="onClick">
        <div class="checkbox">
            <div class="checkbox--checked" v-if="checked"></div>
        </div>
        <div class="label">
            {{label}}
        </div>
    </div>
</template>

<script>
export default {
    name : "Checkbox",
    props: {
        checked: {
            type: Boolean
        },
        label: {
            type : String
        }
    },

    methods: {
        onClick() {
            this.$emit("update:checked", !this.checked);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-checkbox {
        display:flex;
        align-items : center;

        .checkbox {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            border : 1px solid;
            margin-right : .5rem;
            display : flex;
            align-items: center;
            justify-content: center;

            &--checked {
                background : $color-blue;
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
            }
        }

        .label {
            font-size : 1.1em;
            font-weight: normal;
        }
    }
</style>